import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const MODIFY_ROLE = "ADMIN-USER:MODIFY_ROLE";

export interface ModifyRoleAction extends Action {
  type: typeof MODIFY_ROLE;
  organization: OrganizationKeyName;
  userId: number;
  add: boolean;
  role: string;
}

export const modifyRoleAction = (
  organization: OrganizationKeyName,
  userId: number,
  role: string,
  add: boolean
): ModifyRoleAction => ({
  type: MODIFY_ROLE,
  organization,
  userId,
  role,
  add,
});
